export default "__VITE_ASSET__Bv8Q7bHi__"